import {z} from "zod"

import {getJson} from "../http"

export interface GetCustomerInfoParams {
	Type: "SecureCode" | "PaymentPlanID" | "PaymentArrangementID" | "CustomerID" | "Token"
	Value: string
}

const GetCustomerInfoResponseSchema = z.strictObject({
	CustomerID: z.uuid(),
	CustomerRef: z.string(),
	ClientID: z.uuid(),
	ClientName: z.string(),
	OutstandingBalance: z.number(),
	OutstandingBalanceCurrency: z.string(),
	Locale: z.string(),
	SecureCode: z.string(),
})

export type GetCustomerInfoResponse = z.infer<typeof GetCustomerInfoResponseSchema>

export async function getCustomerInfo(params: GetCustomerInfoParams): Promise<GetCustomerInfoResponse> {
	const searchParams = new URLSearchParams({
		Type: params.Type,
		Value: params.Value,
	})
	const data = await getJson(`/app/customer-info?${searchParams.toString()}`, GetCustomerInfoResponseSchema)
	return data
}
